import { render, staticRenderFns } from "./ClubCat.vue?vue&type=template&id=f5337ac2&scoped=true&"
import script from "./ClubCat.vue?vue&type=script&lang=js&"
export * from "./ClubCat.vue?vue&type=script&lang=js&"
import style0 from "./ClubCat.vue?vue&type=style&index=0&id=f5337ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5337ac2",
  null
  
)

export default component.exports